module.exports = __webpack_public_path__ + "files/669763c6b8882762759022fc1f4fde9d.png";